import React, { Fragment } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Layout from '../shims/commonUiLayout';
import TicketListPage from '../pages/ticketing/TicketListPage';
import CreateTicketForm from '../components/tickets/CreateTicketForm';
import TicketDetailPage from '../pages/ticketing/TicketDetailPage';

export default function LayoutRoutes() {
  return (
    <Fragment>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/ticketing/tickets" replace />} />
          <Route path="ticketing/tickets" element={<TicketListPage />} />
          <Route path="ticketing/create" element={<CreateTicketForm />} />
          <Route path="ticketing/tickets/:ticketId" element={<TicketDetailPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/ticketing/tickets" replace />} />
      </Routes>
    </Fragment>
  );
}
